export enum PlatformEnum {
    FACEBOOK = '',
    SNAPCHAT = 'Snapchat',
    META = 'Meta'
}

export type PlatformType = PlatformEnum.FACEBOOK | PlatformEnum.SNAPCHAT | PlatformEnum.META;